
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-help-and-support",
      function () {
        return require("private-next-pages/get-help-and-support/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-help-and-support"])
      });
    }
  